import { DesktopOnly } from 'common/components';
import { useClassName } from 'common/hooks';
import React, { useState } from 'react';
import './title.less';
import { AnimatedText } from '../../AnimatedText';
import CompareTickets from '../../CompareTickets/CompareTickets';

export const Title = ({ title, description, tertiaryColor, ticketsCards }) => {
  const [openCompareTickets, setOpenCompareTickets] = useState(false);

  const handleOpenCompareTickets = () => {
    setOpenCompareTickets(true);
  };
  const handleCloseCompareTickets = () => {
    setOpenCompareTickets(false);
  };

  const className = useClassName('Title');
  return (
    <div
      className={className('container')}
      id="tickets"
      style={{ background: tertiaryColor }}>
      <div className={className('container__inner')}>
        <div className={className('container__inner__data')}>
          <h3 className={className('container__inner__title')}>
            <AnimatedText
              text={title}
              wordClassName={className('container__inner__title__word')}
              letterClassName={className(
                'container__inner__title__word__letter'
              )}
            />
          </h3>
          <p className={className('container__inner__description')}>
            {description}
          </p>
          <DesktopOnly>
            <CompareTickets
              open={openCompareTickets}
              onClose={handleCloseCompareTickets}
              onOpen={handleOpenCompareTickets}
              ticketsCards={ticketsCards}
            />
          </DesktopOnly>
        </div>
      </div>
    </div>
  );
};
